<template>
  <a class="g-link-clear button-create" href="https://customer.railone.io/#/register">
    <span>{{ $t('nav.create') }}</span>
    <img class="button-create__arrow" src="../assets/arrow-right.png" alt="arrow">
  </a>
</template>

<script>

export default {
  name: 'ButtonCreate',
};
</script>

<style lang="scss" scoped>
  .button-create {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 180px;
    height: 30px;
    line-height: 28px;
    padding: 0 2px 0 13px;
    border: 1px solid #4047D6;
    color: #4047D6;
    opacity: .6;
    border-radius: 2px;
    font-size: 14px;
    background: transparent;

    &:hover {
      opacity: 1;
      .button-create__arrow {
        transform: translateX(12px);
      }
    }
  }

  .button-create__arrow {
    margin-left: auto;
    height: 10px;
    transition: transform .3s;
  }
</style>
